import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

var token = localStorage.getItem('token')
export default{
  namespaced:true,
  state: {
    Items : [],
  },
  getters: {
    Items(state){
      return state.Items
    }
  },
  mutations: {
    LlenarItems(state,data){
      state.Items = data
    }
  },
  actions: {
    cargarResponsable:async function({commit}){
      try {
        const  url = "responsable"
        const config = {
          headers: { Authorization: `Bearer ${token}` }
        };
        await axios.get(url,config)
        .then(response => {
          commit('LlenarItems',response.data.success.resultado);       
        })
        .catch(error => {
          this.errorMessage = error.response.data;
          console.error("error!", error);
        }); 
      } catch (error) {
        console.log(error)
      }
    },    
    agregarResponsable: async function({commit,dispatch},datos){
      var  url = "responsable/store"
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };
      await axios.post(url,datos,config)
      .then(response => {
        dispatch('cargarResponsable')     
      })
      .catch(error => {
        this.errorMessage = error.response.data;
        console.error("error!", error);
      }); 
    },
    eliminarResponsable: async function({commit,dispatch},datos){
      const  url = `responsable/${datos.id}`
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };
      await axios.delete(url,config)
      .then(response => { 
        dispatch('cargarResponsable')     
      })
      .catch(error => {
        this.errorMessage = error.response.data;
        console.error("error!", error);
      }); 
    },     
  }

}


